<template>
    <section id="modal_input" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <header>
                    <i class="fa fa-exclamation-triangle fa-4x"></i>
                    <h3 class="modal-title">{{ titulo }}</h3>
                    <p>{{ descricao }}</p>
                </header>

                <main>
                    <label>{{ label }}</label>
                    <textarea rows="6" v-model="value" :placeholder="placeholder" maxlength="500"></textarea>
                </main>

                <div class="modal-footer">
                    <button type="button" @click="ok" class="btn btn-primary" :disabled="!value">
                        <font-awesome-icon v-show="btnRemoveText=='Remover'" :icon="'save'" />
                        <i class="fa fa-check"></i> Salvar
                    </button>
                    <button type="button" :class="[ 'btn', { 'btn-primary': btnRemoveText=='Remover' }, { 'btn-danger': btnRemoveText !='Remover' }]" @click="startRemove" :disabled="!value">
                        <font-awesome-icon v-show="btnRemoveText=='Remover'" :icon="'eraser'" />
                        <span>{{ btnRemoveText }}</span>
                    </button>
                    <button type="button" @click="hide" class="btn btn-default"><i class="fa fa-times"></i> Fechar</button>
                </div>
            </div>
        </div>
    </section>
</template>
  
<script>
export default {
    name: 'InputModal',
    props: {
        titulo: String,
        descricao: String,
        label: String,
        placeholder: String
    },
    data() {
        return {
            value: '',
            fnOk: null,
            btnRemoveText: 'Remover',
            timerInterval: null
        }
    },
    mounted() {
        if (this.inputValue)
            this.value = this.inputValue
    },
    computed: {
        control() {
            return window.jQuery('#modal_input')
        }
    },
    methods: {
        ok() {
            if (this.fnOk) this.fnOk(this.value)
            this.value = ''
        },
        show({ value, fnOk }) {
            this.value = value
            this.fnOk = fnOk
            this.btnRemoveText = 'Remover'
            this.control.modal('show')
        },
        hide() {
            this.control.modal('hide')
        },
        startRemove() {
            if (this.btnRemoveText === 'Remover') {
                this.btnRemoveText = "Clique para cancelar 7s"
                this.startTimer()
            } else {
                this.btnRemoveText = 'Remover'
                clearInterval(this.timerInterval)
            }
        },
        startTimer() {
            const me = this
            this.timerInterval = setInterval(function () {
                let segundos = Number(me.btnRemoveText.replace(/\D/g, ''))
                if (segundos > 0) {
                    let novoSegundo = segundos - 1;
                    me.btnRemoveText = me.btnRemoveText.replace(segundos, novoSegundo)
                } else {
                    clearInterval(me.timerInterval)
                    me.fnOk(null)
                    me.hide()
                }
            }, 1000);
        }
    }
}
</script>
  
<style scoped>
div.modal-content {
    max-width: 600px;
    margin: 10px auto;
}

header {
    padding: 16px;
    text-align: center;
    color: white;
    background-color: #00615C;
}

header h4 {
    margin-top: 10px;
}

main {
    padding: 16px 16px 0px 16px;
    background-color: white;
}

main::-webkit-scrollbar {
    width: 5px;
}

main::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #ccc;
    border-radius: 10px;
}

main::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px #777;
}

main label {
    display: block;
}

main textarea {
    width: 100%;
}

.btn-danger {
    text-transform: none !important;
}
</style>
  


// WEBPACK FOOTER //
// src/components/common/InputModal.vue